import React from 'react'
import { Icon } from '@mobi/component-library/Common/V2'
import {
  Container,
  Explainer,
  InfoCard,
  InfoCardClose,
  InfoCardHeading,
  Title,
} from './Notices.styles'
import { BENEFITS_EXPLAINER_TEXT, VENUE_FEATURE_NAME } from '@core/Areas/VenueMode/constants'

interface InsideVenueNoticeProps {
  onDismiss: () => void
}

export const InsideNotice = ({ onDismiss }: InsideVenueNoticeProps): React.JSX.Element => {
  return (
    <Container>
      <InfoCard>
        <InfoCardHeading>
          <Title>What are {VENUE_FEATURE_NAME}?</Title>
          <Explainer>{BENEFITS_EXPLAINER_TEXT}</Explainer>
        </InfoCardHeading>
        <InfoCardClose>
          <Icon name='SolidXClose' onClick={onDismiss} />
        </InfoCardClose>
      </InfoCard>
    </Container>
  )
}
